module.exports = __webpack_public_path__ + "img/logo.f93815b6.svg";